import { render, staticRenderFns } from "./index.vue?vue&type=template&id=04e99c0e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=04e99c0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e99c0e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ShimmerEffectMultiple: require('/workspace/components/ShimmerEffectMultiple.vue').default,ActivityBlog: require('/workspace/components/ActivityBlog/ActivityBlog.vue').default})
